module.exports = __webpack_public_path__ + "edb5e8e967e564968b8e1867fd669712.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/bosch.jpg
 ** module id = 379
 ** module chunks = 0
 **/